export default {"src":"/_next/static/media/bulma.5fcd03fd.svg","height":373,"width":256,"blurWidth":0,"blurHeight":0};